
import { Component, Prop, Vue } from "vue-property-decorator";

const CLASS = "details-list";

const DEFAULT_ICON = "checkmark-sharp";

@Component({})
export default class DetailsList extends Vue {
  @Prop({ type: [Array, Object], default: () => [] }) readonly items?: any;
  @Prop({ type: Boolean, default: true }) readonly border: boolean;
  @Prop({ type: String, default: DEFAULT_ICON }) readonly icon?: string;
  @Prop({ type: String }) readonly color?: string;
  @Prop({ type: String }) readonly background?: string;

  get classes() {
    const { border, color, background } = this;

    return {
      [`${CLASS}_border`]: border,
      [`${CLASS}_background-${color}`]: background,
    };
  }

  get hasTitle(): boolean {
    return !!this.$slots["title"];
  }

  get hasContent(): boolean {
    return !!this.$slots["default"];
  }

  get hasItems(): boolean {
    return this.items;
  }

  get hasHint(): boolean {
    return !!this.$slots["hint"];
  }
}
